// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.models_styles[data-v-6b670377] {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.model_style_card img[data-v-6b670377] {
  max-height: 120px;
}
.model_style_card h4[data-v-6b670377] {
  font-size: 55px;
  opacity: 0.5;
  position: relative;
  top: 16px;
}
.model_style_card.disabledContent[data-v-6b670377] {
  pointer-events: none !important;
  opacity: 0.9 !important;
}
.model_style_card .cursor_pointer[data-v-6b670377] {
  cursor: pointer;
}
.model_style_card small[data-v-6b670377] {
  font-size: 15px;
  display: block;
  min-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiModels.vue","webpack://./AiModels.vue"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,aAAA;EACA,qCAAA;ACAF;ADGA;EAEI,iBAAA;ACFJ;ADAA;EAOI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;ACJJ;ADQE;EACE,+BAAA;EACA,uBAAA;ACNJ;ADVA;EAoBI,eAAA;ACPJ;ADbA;EAwBI,eAAA;EACA,cAAA;EACA,gBAAA;ACRJ","sourcesContent":["\n.models_styles {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n\n.model_style_card {\n  img {\n    max-height: 120px;\n\n  }\n\n  h4 {\n    font-size: 55px;\n    opacity: 0.5;\n    position: relative;\n    top: 16px;\n  }\n\n\n  &.disabledContent {\n    pointer-events: none !important;\n    opacity: 0.9 !important;\n  }\n\n  .cursor_pointer {\n    cursor: pointer;\n  }\n\n  small {\n    font-size: 15px;\n    display: block;\n    min-height: 20px;\n  }\n\n}\n",".models_styles {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n.model_style_card img {\n  max-height: 120px;\n}\n.model_style_card h4 {\n  font-size: 55px;\n  opacity: 0.5;\n  position: relative;\n  top: 16px;\n}\n.model_style_card.disabledContent {\n  pointer-events: none !important;\n  opacity: 0.9 !important;\n}\n.model_style_card .cursor_pointer {\n  cursor: pointer;\n}\n.model_style_card small {\n  font-size: 15px;\n  display: block;\n  min-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
